// src/auth/platform/authAdapter.ts

import { Capacitor } from '@capacitor/core'
import { webAuth } from './webAuth'
import { appAuth } from './appAuth'

const isApp = Capacitor.isNativePlatform()

export const useAuthAdapter = () => {
  /**
   * 驗證登入狀態
   */
  const checkAuth = async () => {
    return isApp
      ? appAuth.checkAuth()
      : webAuth.checkAuth()
  }

  /**
   * 登入
   */
  const login = async () => {
    return isApp
      ? appAuth.login()
      : webAuth.login()
  }

  /**
   * logout（真正平台差異點）
   */
  const logout = async () => {
    return isApp
      ? appAuth.logout()
      : webAuth.logout()
  }

  const setUser = async (user: any) => {
    if (isApp) {
      return appAuth.setUser(user)
    }
    // Web mode: user data stored in server session
  }

  const getUser = async () => {
    if (isApp) {
      return appAuth.getUser()
    }
    return null // Web mode: user data from server
  }

  const clearPersistence = async () => {
    if (isApp) {
      return appAuth.clear()
    }
    // Web mode uses cookies, cleared by server-side logout
  }

  return {
    checkAuth,
    login,
    logout,

    setUser,
    getUser,
    clearPersistence
  }
}